export default {
  menu: 'Purchase Refunds',
  title: 'Purchase Refunds',

  general: {
    status: {
      all: 'All',
      preInvoice: 'Draft',
      invoice: 'Invoice',
      receipt: 'Pull out',
      incomplete: 'Incomplete',
      deleted: 'Deleted',
      voided: 'Voided'
    },

    notifications: {
      noProductSelected: 'No products selected',
      productsNotExisted: 'Inventory of selected goods is not enough',
      dynamicProductNotExisted: 'The inventory of the {name} is not enough',
      dynamicProductCantReturned: 'The {name} cant returned',

      isExists: {
        message: 'Number of items added',
        dynamicMessage: 'There are {product} in the list'
      },
      increaseCount: {
        message: 'Number of items added',
        dynamicMessage: 'Number of {product} added'
      },
      productNotFount: 'No product found with this barcode',

      insert: {
        success: 'Purchase Refund invoice successfully registered',
        error: 'The purchase Refund invoice registration was accompanied by an error'
      },

      edit: {
        success: 'Purchase Refund invoice successfully updated',
        error: 'Updated purchase Refund invoice failed'
      },

      delete: {
        success: 'The invoice was successfully deleted',
        error: 'Delete returned purchase invoice has error'
      },

      restore: {
        success: 'Invoice successfully restored',
        error: 'Restore return purchase invoice was accompanied by an error'
      },

      refreshStatus: {
        success: 'Purchase invoice status returned successfully',
        error: 'Reverting invoice status returned failed'
      },

      parseError: {
        user: 'Supplier not selected!',
        lines: 'No items selected!',
        storeroom: 'Warehouse not selected!',
        unitPrice: 'The amount of the goods has not been entered!',
        invoiceNumber: 'This invoice number is already selected!',
        quantity: 'The number of selected products is not valid!',
        quantityNotEnough: 'The quantity of {name} is not enough!'
      }
    },

    confirmations: {
      delete: {
        title: 'Delete return purchase invoice confirmation',
        body: 'In case of deleting the returned purchase invoice, all documents and warehouse transfers related to the invoice will be deleted. are you sure?'
      },
      forceDelete: {
        title: 'Confirmation of deletion of return purchase invoice',
        body: 'If the return purchase invoice is deleted, the information of invoice deleted and cant restore it. Are you sure? '
      },
      forceUpdate: {
        title: 'Return Purchase invoice edit confirmation',
        body: 'By edit return purchase invoice, All documents related to this invoice change. Are you sure of confirming edit purchase invoice?'
      }
    }
  },

  list: {
    title: 'Purchase Refunds',

    table: {

      header: {
        number: 'Invoice number',
        creator: 'Creator',
        user: 'Account side',
        date: 'Creation date',
        totalPrice: 'Total amount',
        status: 'Status'
      }
    }
  },

  insert: {
    title: 'Add Purchase Refunds',

    table: {

      header: {
        row: 'Row',
        code: 'Code',
        product: 'Product',
        dynamic: 'Variable',
        number: 'Number',
        unitAmount: 'Unit amount',
        amount: 'Total amount',
        store: 'Store',
        action: '#'
      }
    }
  },

  invoice: {
    title: 'Purchase Refund Invoice',
    dynamicTitle: 'Purchase Refund Invoice No. {invoiceId}',

    print: {
      preInvoice: 'Draft',
      invoice: 'Purchase refund invoice'
    },

    logs: {
      title: 'Purchase Refund Invoice Logs'
    }
  },

  edit: {
    title: 'Edit Purchase Refund Invoice',
    dynamicTitle: 'Edit Purchase Refund Invoice {invoiceId}'
  },

  trash: {
    title: 'Purchase refund invoice trash list'
  },

  refreshStatus: {
    title: 'Purchase Refund Invoice Status',

    labels: {
      description: 'Note that if the invoice status is returned, all documents and delivery note related to each status will be deleted',
      accept: 'Confirm',
      cancel: 'Cancel'
    }
  }
}
